import { useTranslation } from 'react-i18next';

import { Wrapper, Paragraph } from '../../../../shared/ModalComponents';
import { StyledTitle, ButtonGroup } from './StyledComponents';
import { Button } from '../../../../shared/FormStyles/Button';

const SendNow = ({ onCancel, onConfirm }) => {
  const { t } = useTranslation('send');

  return (
    <Wrapper>
      <StyledTitle>{t('followUp.confirmSendTitle')}</StyledTitle>
      <Paragraph>{t('followUp.confirmSendText')}</Paragraph>
      <ButtonGroup>
        <Button variant="tertiary" onClick={onCancel}>
          {t('followUp.noButton')}
        </Button>
        <Button variant="containedBlue" onClick={onConfirm}>
          {t('followUp.yesButton')}
        </Button>
      </ButtonGroup>
    </Wrapper>
  );
};

export default SendNow;
